/**
* @file Satisfied customers carousel
*/

import Slider from 'integration-common-files/src/js/03-organisms/carousel/slider';

export default function loadProccessStepsCarousel(){
  const carousel = document.querySelector('.satisfied-customers__carousel-reviews');
  if(carousel) {
    new Slider({
      selector: '.satisfied-customers__carousel-reviews',
      controlsAbsolute: true,
      responsive:{
        0: {
          controls: false,
          alignment: 'top',
          autoHeight: true

        },
        768: {
          controls: true,
          nav: false,
          alignment: 'center',
          autoHeight: false
        }
      }
    })
  }
};
